import { schema } from './cache';
import { cacheSize } from './config';

export function parseData(json: string | null) {
  if (json === null) {
    return [];
  }

  try {
    const data = JSON.parse(json);
    const parsed = schema.safeParse(data);
    if (!parsed.success) {
      return [];
    }
    return parsed.data.slice(0, cacheSize);
  } catch {
    return [];
  }
}
